import { useAuth } from "contexts/AuthContext";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Import all possible dashboard components
import AdminDashboard from "./components/AdminDashboard";
import PastorDashboard from "./components/PastorDashboard";
import StaffDashboard from "./components/StaffDashboard";
import MemberDashboard from "./components/MemberDashboard";
import TreasurerDashboard from "./components/TreasurerDashboard";

function Dashboard() {
  const { user } = useAuth();

  // Role-based dashboard components
  const getDashboardComponent = () => {
    switch (user?.role) {
      case "admin":
        return <AdminDashboard />;
      case "pastor":
        return <PastorDashboard />;
      case "staff":
        return <StaffDashboard />;
      case "member":
        return <MemberDashboard />;
      case "treasurer":
        return <TreasurerDashboard />;
      default:
        return <DefaultDashboard />;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {getDashboardComponent()}
      <Footer />
    </DashboardLayout>
  );
}

// Default dashboard for unknown roles
function DefaultDashboard() {
  return (
    <MDBox py={3}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <MDBox textAlign="center">
            <h3>Welcome to Ecclesia Management System</h3>
            <p>Please contact your administrator for dashboard access</p>
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Dashboard;
